<template>
	<!--
    	作者：YX
    	时间：2017-10-10
    	描述：透支记录
    -->
	<div class="over_draft">
		
		<div class="over_search" style="margin-top: 20px;">
			<el-form :inline="true" :model="seach" class="demo-form-inline" @keyup.enter.native="search">
				<el-form-item label="业主姓名">
					<el-input v-model="seach.owner_name" placeholder="业主姓名" style="width:100px;"></el-input>
				</el-form-item>
				<!--<el-form-item label="业主电话">
					<el-input v-model="seach.owner_phone" placeholder="业主电话" style="width:130px;" :maxlength="11"></el-input>
				</el-form-item>-->
				<el-form-item label="业主类型">
					<el-select v-model="seach.nature" placeholder="请选择" style="width: 110px;">
						<el-option v-for="item in natures" :key="item.num" :label="item.value" :value="item.num">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="表类型">
					<el-select v-model="seach.typess" placeholder="请选择" style="width: 90px;">
						<el-option v-for="item in typess" :key="item.id" :label="item.label" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="地址">
					<el-input v-model="seach.address" placeholder="地址" style="width:120px;"></el-input>
				</el-form-item>
				<el-form-item label="户号">
					<el-input v-model="seach.account" placeholder="户号" style="width:120px;" :maxlength="12"></el-input>
				</el-form-item>
				<el-form-item label="表号">
					<el-input v-model="seach.code" placeholder="表号" style="width:120px;" :maxlength="12"></el-input>
				</el-form-item>
				<el-form-item label="透支开始日期">
					<el-date-picker v-model="seach.startTime" type="date" placeholder="选择开始日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="透支结束日期">
					<el-date-picker v-model="seach.endTime" type="date" placeholder="选择结束日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="订单状态">
					<el-select v-model="seach.status" placeholder="请选择" style="width: 110px;">
						<el-option v-for="item in types" :key="item.id" :label="item.label" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="search">查询</el-button>
					<el-button type="primary" @click="resetting">重置</el-button>
					<el-button type="primary" @click="downoverdraft()">导出</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="over_search_data">
			<el-table :data="lists" border style="width:1652px;text-align:center;margin-bottom: 10px;font-size:12px;" v-on:sort-change="sortChange">
				<el-table-column prop="account" label="户号"  align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="code" label="表号"  align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="tra_type" label="表类型"  align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="nature" label="业主类型"  align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="owner_name" label="业主姓名" align="center" sortable="custom">
				</el-table-column>
				<!--<el-table-column prop="owner_phone" label="业主电话"  align="center" sortable="custom">
				</el-table-column>-->
				<el-table-column prop="overdraft" label="透支金额/吨数"  width="135" align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="amount" label="透支水量（吨）" width="144" align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="status" label="状态"  align="center" sortable="custom">
					<template scope="scope">
						<el-tag v-if="2 == scope.row.status" type="gray">未处理</el-tag>
						<el-tag v-if="4 == scope.row.status" type="primary">已处理</el-tag>
						<el-tag v-if="3 == scope.row.status" type="success">充值成功</el-tag>
						<el-tag v-if="-3 == scope.row.status" type="danger">充值失败</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="address" label="地址" width="250" align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="create_time" label="时间" width="170" align="center" sortable="custom">
				</el-table-column>
			</el-table>
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="pageSize" layout="total,prev, pager, next" :total="total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import { mapState} from 'vuex'
	export default {
		name: 'over-draft',
		data() {
			return {
				seach: {
					owner_name: "",
					owner_phone: "",
					code: "",
					account: "",
					startTime: '',
					endTime: '',
					status: '',
					nature: '',
					address:'',
					typess:''
				},
				typess: [
					{
						id: '7',
						label: '水表'
					},
					{
						id: '10',
						label: '多功能单相'
					},
					{
						id: '11',
						label: '多功能三相'
					}
				],
				currentPage: '',
				types: [{
						id: '4',
						label: '已处理'
					},
					{
						id: '3',
						label: '充值成功'
					},
					{
						id: '-3',
						label: '充值失败'
					},
				],
				natures: [/*{
						num: '0',
						value: '居民',
					},
					{
						num: '1',
						value: '自营'
					},
					{
						num: "2",
						value: '联营'
					},
					{
						num: '3',
						value: '出租'
					},
					{
						num:'4',
						value:'物业动力'
					},
					{
						num:'5',
						value:'居民配套'
					},
					{
						num: '9',
						value: '备用'
					},
*/
				],
				lists: [{
					account: '',
					code: '',
					owner_name: '',
					owner_phone: '',
					overdraft: '',
					status: '',
					address: '',
					create_time: '',
					nature: ''
				}, ],
				total: 0,
				pageSize: 15,
				prop:'',
				order:'',
			}
		},
		created:function(){
			this.searchNature()
			this.search()
		},
		methods: {
			searchNature(){
				this.$jssdk.member.getNature({
					
				},(res) =>{
					this.natures = res
					console.log(res)
				})
			},
			sortChange(item) {
				var order = item.order
				var prop = item.prop
				this.prop = prop
				this.order = order
				this.currentPage = '1'
				const ownerName = this.seach.owner_name
				const ownerPhone = this.seach.owner_phone
				const code = this.seach.code
				const account = this.seach.account
				const startTime = this.seach.startTime
				const endTime = this.seach.endTime
				const status = this.seach.status
				let nature = this.seach.nature
				var address = this.seach.address
				let typess = this.seach.typess
				this.$jssdk.order.overDraft({
					owner_name: ownerName,
					owner_phone: ownerPhone,
					code: code,
					account: account,
					start_time: startTime,
					end_time: endTime,
					status: status,
					is_export: '0',
					nature: nature,
					sort_by: prop,
					sort_to: order,
					address:address,
					type: typess
				}, (data) => {
					this.lists = data.list.data
					this.total = data.list.total
					for(var i = 0; i < data.list.data.length; i++) {
						if(data.list.data[i].nature == '0') {
							this.lists[i].nature = '居民'
						}
						if(data.list.data[i].nature == '1') {
							this.lists[i].nature = '自营'
						}
						if(data.list.data[i].nature == '2') {
							this.lists[i].nature = '联营'
						}
						if(data.list.data[i].nature == '3') {
							this.lists[i].nature = '出租'
						}
						if(data.list.data[i].nature == '4'){
							this.lists[i].nature = '物业动力'
						}
						if(data.list.data[i].nature == '5'){
							this.lists[i].nature = '居民配套'
						}
						if(data.list.data[i].nature == '9') {
							this.lists[i].nature = '备用'
						}
					}
				}, (err) => {
					return this.$message({
						type: 'warning',
						message: err.msg,
						duration: 1000
					})
				})
			},
			search() {
				this.currentPage = '1'
				const ownerName = this.seach.owner_name
				const ownerPhone = this.seach.owner_phone
				const code = this.seach.code
				const account = this.seach.account
				const startTime = this.seach.startTime
				const endTime = this.seach.endTime
				const status = this.seach.status
				let nature = this.seach.nature
				var address = this.seach.address
				let typess = this.seach.typess
				this.$jssdk.order.overDraft({
					owner_name: ownerName,
					owner_phone: ownerPhone,
					code: code,
					account: account,
					start_time: startTime,
					end_time: endTime,
					status: status,
					is_export: '0',
					nature: nature,
					address:address,
					type: typess
				}, (data) => {
					this.lists = data.list.data
					this.total = data.list.total
					for(var i = 0; i < data.list.data.length; i++) {
						if(data.list.data[i].nature == '0') {
							this.lists[i].nature = '居民'
						}
						if(data.list.data[i].nature == '1') {
							this.lists[i].nature = '自营'
						}
						if(data.list.data[i].nature == '2') {
							this.lists[i].nature = '联营'
						}
						if(data.list.data[i].nature == '3') {
							this.lists[i].nature = '出租'
						}
						if(data.list.data[i].nature == '4'){
							this.lists[i].nature = '物业动力'
						}
						if(data.list.data[i].nature == '5'){
							this.lists[i].nature = '居民配套'
						}
						if(data.list.data[i].nature == '9') {
							this.lists[i].nature = '备用'
						}
					}
				}, (err) => {
					return this.$message({
						type: 'warning',
						message: err.msg,
						duration: 1000
					})
				})
			},
			downoverdraft() {
				const ownerName = this.seach.owner_name
				const ownerPhone = this.seach.owner_phone
				const code = this.seach.code
				const account = this.seach.account
				const startTime = this.seach.startTime
				const endTime = this.seach.endTime
				const status = this.seach.status
				const nature = this.seach.nature
				var address = this.seach.address
				let typess = this.seach.typess
				this.$jssdk.order.overDraft({
					owner_name: ownerName,
					owner_phone: ownerPhone,
					code: code,
					account: account,
					start_time: startTime,
					end_time: endTime,
					status: status,
					is_export: '1',
					nature: nature,
					address:address,
					sort_by: this.prop,
					sort_to: this.order,
					type: typess
				}, (data) => {
					window.location.href = data.url
				}, (err) => {
					return this.$message({
						type: 'warning',
						message: err.msg,
						duration: 1000
					})
				})
			},
			resetting() {
				this.seach.owner_name = ''
				this.seach.owner_phone = ''
				this.seach.code = ''
				this.seach.account = ''
				this.seach.startTime = ''
				this.seach.endTime = ''
				this.seach.status = ''
				this.seach.nature = ''
				this.seach.address = ''
				this.seach.typess = ''
			},
			handleSizeChange(val) {},
			handleCurrentChange(val) {
				const ownerName = this.seach.owner_name
				const ownerPhone = this.seach.owner_phone
				const code = this.seach.code
				const account = this.seach.account
				const startTime = this.seach.startTime
				const endTime = this.seach.endTime
				const status = this.seach.status
				let nature = this.seach.nature
				var address = this.seach.address
				let typess = this.seach.typess
				this.$jssdk.order.overDraft({
					owner_name: ownerName,
					owner_phone: ownerPhone,
					code: code,
					account: account,
					start_time: startTime,
					end_time: endTime,
					status: status,
					page: val,
					nature: nature,
					sort_by: this.prop,
					sort_to: this.order,
					address:address,
					typs:typess
				}, (data) => {
					this.lists = data.list.data
					for(var i = 0; i < data.list.data.length; i++) {
						if(data.list.data[i].nature == '0') {
							this.lists[i].nature = '居民'
						}
						if(data.list.data[i].nature == '1') {
							this.lists[i].nature = '自营'
						}
						if(data.list.data[i].nature == '2') {
							this.lists[i].nature = '联营'
						}
						if(data.list.data[i].nature == '3') {
							this.lists[i].nature = '出租'
						}
						if(data.list.data[i].nature == '4'){
							this.lists[i].nature = '物业动力'
						}
						if(data.list.data[i].nature == '5'){
							this.lists[i].nature = '居民配套'
						}
						if(data.list.data[i].nature == '9') {
							this.lists[i].nature = '备用'
						}
					}
				})
			},
		},
		computed:{
			naturesData(){
				return this.natures = this.nature
			},
			...mapState(['nature'])
		},
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// overDraft.vue?0d07c25d